module.exports = __webpack_public_path__ + "img/5.9d398107.png";